// src/Dashboard/pages/teacher/ListingAdherents/components/ListingAdherentsGroupToolbar.jsx

import React from "react";
import { FaDownload, FaEnvelope, FaLayerGroup, FaUsers } from "react-icons/fa";

export default function ListingAdherentsGroupToolbar({
  filters = {},
  groupName,
  season,
  count = 0,
  total = 0,
  onCopyEmails,
  onExportCsv,
  onExportCSV,
}) {
  const activeGroup = groupName || filters.filterGroup || "Tous les groupes";
  const activeSeason = season || filters.selectedSeason || "Toutes saisons";
  const exportHandler = onExportCsv || onExportCSV;

  return (
    <div className="rounded-2xl bg-slate-50 p-4 ring-1 ring-slate-200/70 dark:bg-slate-800/40 dark:ring-slate-700/70">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="min-w-0">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            <FaLayerGroup />
            Sélection active
          </div>

          <h3 className="mt-1 truncate text-xl font-bold text-slate-900 dark:text-white">
            {activeGroup}
          </h3>

          <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
            Saison {activeSeason} · {count} affiché{count > 1 ? "s" : ""} sur{" "}
            {total}
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-2">
          <span className="inline-flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700">
            <FaUsers />
            {count}
          </span>

          <button
            type="button"
            onClick={onCopyEmails}
            className="inline-flex items-center gap-2 rounded-xl bg-white px-3 py-2 text-sm font-bold text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-50 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
          >
            <FaEnvelope />
            Emails
          </button>

          <button
            type="button"
            onClick={exportHandler}
            className="inline-flex items-center gap-2 rounded-xl bg-violet-600 px-3 py-2 text-sm font-bold text-white transition hover:bg-violet-700"
          >
            <FaDownload />
            Export CSV
          </button>
        </div>
      </div>
    </div>
  );
}